var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"info-card",attrs:{"to":{ name: 'CityDistrict', params: { slug: _vm.city, district: _vm.district.slug }}}},[_c('div',[_c('div',{staticClass:"info-card__top"},[_c('h3',{staticClass:"info-card__name"},[_vm._v(_vm._s(_vm.district.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }